import { useCallback } from 'react';
import { renderCard } from 'interactive-cards/js/renderCard';
import styled from 'styled-components';
import { GREAT_WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { useAppDispatch, useAppSelector } from '../../buildStore';
import ErrorBoundary from '../../components/ErrorBoundary';
import { publishInteractiveCardAction } from '../actions/publishInteractiveCardAction';
import { getInteractiveCardByInstanceId } from '../selectors/getInteractiveCardByInstanceId';
import { jsx as _jsx } from "react/jsx-runtime";
const CardWrapper = styled.div.withConfig({
  displayName: "InteractiveCard__CardWrapper"
})(["margin:8px 16px;padding:12px;border:1px solid ", ";border-radius:8px;"], GREAT_WHITE);
const InteractiveCard = ({
  cardInstanceId
}) => {
  const dispatch = useAppDispatch();
  const card = useAppSelector(state => getInteractiveCardByInstanceId(state, cardInstanceId));
  const handleAction = useCallback((actionName, payload) => {
    var _card$cardId;
    dispatch(publishInteractiveCardAction({
      cardInstanceId,
      cardId: (_card$cardId = card === null || card === void 0 ? void 0 : card.cardId) !== null && _card$cardId !== void 0 ? _card$cardId : null,
      actionName,
      payload
    }));
  }, [dispatch, cardInstanceId, card]);
  if (!card || !card.body || !card.locale) {
    return null;
  }
  return /*#__PURE__*/_jsx(CardWrapper, {
    children: /*#__PURE__*/_jsx(ErrorBoundary, {
      errorLoggingTitle: "InteractiveCard renderCard",
      renderError: () => null,
      children: renderCard(card.body, handleAction, {
        locale: card.locale,
        keys: {
          renderKey: cardInstanceId,
          responseKey: String(card.cardInstanceVersion)
        },
        context: card.context,
        dynamicText: card.dynamicText,
        errorReason: card.errorReason
      })
    })
  });
};
InteractiveCard.displayName = 'InteractiveCard';
export default InteractiveCard;